import { t } from 'i18next';

import { ButtonType, Size } from 'coreOld/enums';

import ConfirmationView from './ConfirmationView';

interface IProps {
  isOpen: boolean;
  title: string;
  size: Size;
  message: string | JSX.Element;
  confirmBtnLabel?: string;
  confirmBtnType?: ButtonType;
  cancelBtnLabel?: string;
  cancelBtnType?: ButtonType;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const Confirmation = ({
  title,
  size,
  message,
  confirmBtnLabel = t('buttonLabelConfirm'),
  confirmBtnType = ButtonType.SUCCESS,
  cancelBtnLabel = t('buttonLabelCancel'),
  cancelBtnType = ButtonType.CANCEL_INVERTED,
  onConfirm,
  onCancel,
  isOpen,
}: IProps) => {
  return (
    <ConfirmationView
      title={title}
      size={size}
      message={message}
      confirmBtnLabel={confirmBtnLabel}
      confirmBtnType={confirmBtnType}
      cancelBtnLabel={cancelBtnLabel}
      cancelBtnType={cancelBtnType}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isOpen={isOpen}
    />
  );
};

export default Confirmation;
